export default __webpack_public_path__ + "static/media/location.a932220f.svg";